import { Component, Inject, Input } from '@angular/core';
import { CaptionService } from '../../../../../utils/shared-services/caption.service';

@Component({
    selector: 'table-store-info',
    templateUrl: 'src/app/features/head-office-portal/widgets/charts/templates/table-store-opendate.html',
    standalone: false
})
export class TableStoreInfo {
    public captions: any;

    @Input() public storeData: Array<{ storeNum: number | string, storeID: number | string, storeName: string, openDate: string }> = [];
    @Input() public headers: string[];

    constructor(
        @Inject(CaptionService) private captionService,
    ) {
        this.captions = this.captionService.captions;
    }

    ngOnInit() { }
}
